export enum ContextualMenuType {
  Permission = 0,
  Language = 1,
  Receiver = 2,
}

export enum PermissionType {
  Admin = 'ADMIN',
  Company = 'ADMIN_COMPANY',
  Distributor = 'ADMIN_DISTRIBUTOR',
  End_Company = 'END_COMPANY',
  Viewer = 'VIEWER',
}

export enum Sections {
  Info = 'Info',
  Edit = 'Edit',
  Create = 'Create',
}

export enum Steps {
  INFO = 0,
  USERS = 1,
  SETTINGS = 2,
}

export class User {
  _id: string;
  index?: number;
  companyID: string;
  companyName: string;
  companyColor: string;
  name: string;
  lastName: string;
  email: string;
  phone: string;
  role: PermissionType;
  language: string;
  expand: boolean;

  constructor(language) {
    this.name = '';
    this.lastName = '';
    this.email = '';
    this.phone = '';
    this.role = PermissionType.End_Company;
    this.language = language;
    this.expand = false;
  }
}

export class Receiver {
  name: string;
  apiKey: string;
  ip: string;
  receiverEventPort: number;
  snifferPort: number;
  gestionPort: number;
  bridgePort: number;
  monitoringPort: number;
  panID: string;
  receiverNumber: string;
  logo: string;
  colorPalette: {
    primary: string;
    secondary: string;
  };
  testPHourConfiguration: {
    lowControl: number;
    goodControl: number;
  };
}

export class KaironConfig {
  isEnabled: boolean;
  reminderConfig: {
    retryMinutes: number;
    toleranceMinutes: number;
  };
  eventDetectionConfig: {
    radiusMeters: number;
    windowSeconds: number;
    threshold: number;
    eventCID: string;
  };
  voice: {
    isEnabled: boolean;
    callRetryLimit: number;
    cidFalseAlarm: string;
    cidDuress: string;
    cidNoContact: string;
    cidCommFailure: string;
  };
}

export class MaiaConfig {
  isEnabled: boolean;
  perimetralConfig: {
    startHour: string;
    endHour: string;
  };
}

export class CompanyType {
  _id: string;
  name: string;
  expand: boolean;
  apiKey: string;
  snifferPort: number;
  receiverEventPort: number;
  notificationEmail: string[];
  webUrl: string;
  location: {
    lat: number;
    lng: number;
  };
  email: string;
  techUserCode: string;
  linkName: string;
  receiverName: string;
  contact: string;
  whatsappNumber: string;
  language: string;
  users: User[];
  colorPalette: {
    primary: string;
    secondary?: string;
  };
  logo: string;
  receivers: Receiver[];

  weakSignalThreshold: number;
  excellentSignalThreshold: number;
  powerCutDistance: number;
  toleranceTime: number;
  reminderTime: number;
  kairon: KaironConfig;
  maia: MaiaConfig;
  isKaironEnabled?: boolean;
  country: {
    iso: string;
  };
  ezvizAccountName: string;
  ip: string;

  constructor() {
    this.location = {
      lat: 0,
      lng: 0,
    };
    this.colorPalette = {
      primary: undefined,
    };
    this.users = [];
    this.notificationEmail = [];
  }
}
